import { JsonObject, JsonProperty } from 'json2typescript';

import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';
import { TraderInterface } from '../../../core';

@JsonObject('Trader')
export class Trader implements TraderInterface {
    @JsonProperty('Id', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('CNMV', StringAdapter, true)
    private _cnmv: string = undefined;

    @JsonProperty('Nif', StringAdapter, true)
    private _nif: string = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    get id(): Id {
        return this._id;
    }

    get cnmv(): string {
        return this._cnmv;
    }

    get nif(): string {
        return this._nif;
    }

    get name(): string {
        return this._name;
    }
}
